/**
 * Used mostly for store wrapping, when we cannot pass undefined
 */
// Using 'any' intentionally here to bypass TypeScript's type checking
// as this is a type assertion helper
const typeWrapper = <T = string>(value: unknown) => value as T;

export { typeWrapper };
